module.exports = __webpack_public_path__ + "img/line-bar.6a3391eb.svg";